import * as t from "io-ts";
import { BaseId } from "./BaseId";
import { TagBody } from "./TagBody";

export const Tag = t.intersection([BaseId, TagBody]);

export type Tag = BaseId & TagBody;
